// extracted by mini-css-extract-plugin
export default {"modal":"create-quotation_modal__6dZw0"};